import format from 'date-fns/format';

export const INPUT_DATE_FORMAT = 'MM/DD/YYYY';
export const PROFILE_DATE_FORMAT = 'YYYYMMDD';

/**
 * Converts a date input field to a Date object
 */
export function convertDateToInput(date: string | number | Date) {
    return format(date, INPUT_DATE_FORMAT);
}

/**
 * Formats a date to YYYYMMDD format expected by profile
 */
export function formatProfileBirthdate(date: string | number | Date) {
    return format(date, PROFILE_DATE_FORMAT);
}

/**
 * Converts a date input field to a Date object
 */
export function parseDateInput(fieldValue: string) {
    const [mm, dd, yyyy]: number[] = fieldValue.split('/').map((n: string) => parseInt(n, 10));
    return new Date(yyyy, mm - 1, dd);
}

/**
 * Converts a Dalton profile date string (YYYYMMDD) to a Date object
 */
export function parseDateString(dateString: string) {
    const match = dateString.match(/^(\d{4})(\d{2})(\d{2})$/);

    if (!match) {
        return null;
    }

    const y = parseInt(match[1], 10);
    const m = parseInt(match[2], 10) - 1;
    const d = parseInt(match[3], 10);

    return new Date(y, m, d);
}
